import React from 'react';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import style from './create-order-from-asn-modal-body-content.module.less';
import { messages } from './messages';
import { StoreDropDown } from '../../../../../../components/store-dropdown';

/**
 * @param {object} props
 * @param {string} [props.createdOrderNumber]
 * @param {boolean} props.isInProgress
 * @param {string} [props.errorMessage]
 * @param {(storeGuid: string) => void} props.onStoreSelected
 * @param {string} [props.selectedStoreGuid]
 * @param {Array<object>} props.stores
 * @returns {JSX.Element | null}
 */
export const CreateOrderFromAsnModalBodyContent = ({
  createdOrderNumber,
  isInProgress,
  errorMessage,
  onStoreSelected,
  selectedStoreGuid,
  stores,
}) => {
  // Show loading state
  if (isInProgress) {
    return (
      <FlexColumn className={style['loading-indicator-wrapper']} gap={Gap.Space16}>
        <LoadingIndicator className={style['loading-indicator']} />
        <Text className={style['loading-indicator-text']} textType={TextType.Paragraph} value={messages.configuringShipmentsText} />
      </FlexColumn>
    );
  }

  // Show error state
  if (errorMessage) {
    return (
      <BannerMessageV2
        content={<Text textType={TextType.Paragraph} value={errorMessage} />}
        layout={BannerLayout.Full}
        status={BannerStatus.Error}
      />
    );
  }

  // Show success state
  if (createdOrderNumber) {
    return (
      <FlexColumn gap={Gap.Space16}>
        <Text formattedMessageValues={{ orderNumber: createdOrderNumber }} textType={TextType.H4} value={messages.orderNumberLabel} />
        <FlexColumn gap={Gap.Space8}>
          <Text textType={TextType.Paragraph} value={messages.additionalInfoRequiredText} />
          <ul className={style['bullet-list']}>
            <Text className={style['bullet-list-item']} element='li' textType={TextType.Paragraph} value={messages.packageDimensionsItem} />
            <Text className={style['bullet-list-item']} element='li' textType={TextType.Paragraph} value={messages.packageWeightItem} />
            <Text className={style['bullet-list-item']} element='li' textType={TextType.Paragraph} value={messages.shippingServiceItem} />
          </ul>
        </FlexColumn>
      </FlexColumn>
    );
  }

  return (
    <FlexColumn gap={Gap.Space16}>
      <Text textType={TextType.Paragraph} value={messages.initialModalExplanation} />
      <div>
        <Text textType={TextType.Label} value={messages.storeSelectionLabel} />
        <StoreDropDown onStoreSelected={onStoreSelected} selectedStoreGuid={selectedStoreGuid} stores={stores} />
      </div>
      <BannerMessageV2
        content={<Text textType={TextType.Paragraph} value={messages.automationWarning} />}
        layout={BannerLayout.Full}
        status={BannerStatus.Warning}
      />
    </FlexColumn>
  );
};
